import { useGetCurrentVersion } from "../../hooks/useImages";
import { OldVersionMessageBar } from "../OldVersionMessageBar";

interface OldImageVersionMessageBarProps {
  imageId: string;
}

export const OldImageVersionMessageBar = (
  props: OldImageVersionMessageBarProps
) => {
  const { imageId } = props;

  const {
    data: currentVersion,
    isLoading: isCurrentLoading,
    isRefetching: isCurrentRefetching,
  } = useGetCurrentVersion(imageId);

  return (
    <OldVersionMessageBar
      type="image"
      currentVersion={{
        versionId: currentVersion?.versionId ?? "",
        title: currentVersion?.title ?? "",
      }}
      isLoading={isCurrentLoading}
      isRefetching={isCurrentRefetching}
    />
  );
};
